export default __webpack_public_path__ + "static/media/messageIconActiveWhite.5a6e70f5.svg";